import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-gradient-to-br from-primary-500 to-accent-500 rounded-2xl overflow-hidden">
          <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">{appData.title}</h2>
            <p className="text-background-50/90 text-sm md:text-base leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">{appData.desc}</p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-6">
              {appData.features.map((f, i) => (
                <span key={i} className="px-4 py-1.5 bg-background-50/20 text-background-50 text-sm rounded-full border border-background-50/30 whitespace-nowrap">
                  {f}
                </span>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="w-full sm:w-auto px-8 py-3 bg-background-50 hover:bg-background-100 text-primary-600 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm">
                <i className="ri-apple-fill mr-2"></i>App Store 下载
              </button>
              <button className="w-full sm:w-auto px-8 py-3 border border-background-50/50 hover:bg-background-50/10 text-background-50 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm">
                <i className="ri-android-fill mr-2"></i>Android 下载
              </button>
            </div>
          </div>
          <div className="flex-1 w-full max-w-md lg:max-w-none p-4 md:p-0">
            <div className="relative w-3/4 mx-auto aspect-[9/16] max-w-[280px] rounded-3xl overflow-hidden border-4 border-background-50/30">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20video%20streaming%20mobile%20app%20interface%20design%2C%20variety%20show%20thumbnails%20grid%20layout%2C%20warm%20orange%20and%20golden%20accent%20colors%2C%20clean%20dark%20UI%20with%20play%20buttons%2C%20entertainment%20content%20categories%2C%20sleek%20minimalist%20mobile%20screen%20mockup&width=560&height=1000&seq=app-screen&orientation=portrait"
                alt="香蕉影视移动客户端界面"
                className="w-full h-full object-cover object-top"
                title="香蕉影视移动客户端"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}